import { useEffect } from 'react';
import mitt from 'mitt';

const eventBus = mitt();

export const EventName = {
    // 刷新用户详情
    USER_DETAIL_REFRESH: 'USER_DETAIL_REFRESH',

    GAS_UPDATE: 'GAS_UPDATE',
    GAS_DELETE: 'GAS_DELETE',
    WATER_UPDATE: 'WATER_UPDATE',
    WATER_DELETE: 'WATER_DELETE',
    ELECTRICITY_UPDATE: 'ELECTRICITY_UPDATE',
    ELECTRICITY_DELETE: 'ELECTRICITY_DELETE',
    RECIVED_WORKORDER_MESSAGE: 'RECIVED_WORKORDER_MESSAGE',
    SEND_WORKORDER_MESSAGE: 'SEND_WORKORDER_MESSAGE',
    CLOSE_WORKORDER: 'CLOSE_WORKORDER',
    CLOSE_EQUIPMENT: 'CLOSE_EQUIPMENT',
    CLOSE_GAS: 'CLOSE_GAS',
    CLOSE_WATER: 'CLOSE_WATER',
    CLOSE_RESULT_SEARCH: 'CLOSE_RESULT_SEARCH',
    CLOSE_ELECTRICITY: 'CLOSE_ELECTRICITY',
    UPDATE_CERTIFICATION_STATUS: 'UPDATE_CERTIFICATION_STATUS',
    REFRESH_CERTIFY_REQUEST: 'REFRESH_CERTIFY_REQUEST',
    MARK_ALL_NOTIFICATIONS_READ: 'MARK_ALL_NOTIFICATIONS_READ',
    REFRESH_WORKORDER_LIST: 'REFRESH_WORKORDER_LIST',
    REFRESH_EQUIPMENT_LIST: 'REFRESH_EQUIPMENT_LIST',
    REFRESH_WORKORDER_WRAPPER_LIST: 'REFRESH_WORKORDER_WRAPPER_LIST',
    REFRESH_PM_CHECKLIST_LIST: 'REFRESH_PM_CHECKLIST_LIST',
    REFRESH_PM_PLAN_LIST: 'REFRESH_PM_PLAN_LIST',
    // 消息中心事件
    OPEN_MESSAGE_CENTER: 'OPEN_MESSAGE_CENTER',
    OPEN_CHAT_WITH_CONVERSATION: 'OPEN_CHAT_WITH_CONVERSATION',
}

export const useEventBus = (eventName, callback) => {
    useEffect(() => {
        eventBus.on(eventName, callback);
        return () => {
            eventBus.off(eventName, callback);
        };
    }, [eventName, callback]);
};

export const emitEvent = (eventName, data) => {
    eventBus.emit(eventName, data);
};
